var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1",attrs:{"id":"geoshape00"}},[_c('div',[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.endPolygon}},[_vm._v(_vm._s(_vm.labels.map.endEdit))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }